<template>
  <div style="background: #f0ede5">
    <v-main>
      <v-container>
        <div
          id="button-prev"
          class="swiper-button-prev-reviews"
          slot="button-prev"
          style="display: none"
        ></div>
        <div
          id="button-next"
          class="iconBackground swiper-button-next-reviews"
          slot="button-next"
          style="display: none"
        ></div>
        <div style="padding: 60px 0px">
          <h2 class="section-name">Kundenstimmen</h2>
          <swiper
            v-if="true"
            ref="mySwiper"
            :options="swiperOptions"
            style="margin-top: 40px"
            v-show="
              !$vuetify.breakpoint.smAndDown &&
              reviewsList.length > 0 &&
              !isShowLoader
            "
          >
            <swiper-slide
              v-for="review in reviewsList"
              :key="review.id"
              :cssMode="true"
              :navigation="true"
              :pagination="true"
              :mousewheel="true"
              :keyboard="true"
              :modules="swiperOptions.modules"
            >
              <review-card :review="review" @goNext="goNext" @goPrev="goPrev" />
            </swiper-slide>
          </swiper>
          <div class="custom-pagination" style="margin-top: 32px"></div>
          <v-main
            v-show="
              $vuetify.breakpoint.smAndDown &&
              reviewsList.length > 0 &&
              !isShowLoader
            "
          >
            <v-container>
              <swiper
                ref="mySwiper"
                :options="swiperMobileOptions"
                :style="
                  $vuetify.breakpoint.smAndDown
                    ? 'margin-top: 20px;'
                    : 'margin-top: 40px;margin-left: 10svw'
                "
              >
                <swiper-slide
                  v-for="review in reviewsList"
                  :key="review.id"
                  :cssMode="true"
                  :navigation="true"
                  :pagination="true"
                  :mousewheel="true"
                  :keyboard="true"
                  :modules="swiperOptions.modules"
                >
                  <review-card :review="review" /> </swiper-slide
              ></swiper>
              <v-row
                no-gutters
                align="center"
                justify="center"
                style="margin-top: 20px"
              >
                <div
                  class="iconBackground swiper-button-prev-choose-us"
                  slot="button-prev"
                  style="margin-right: 24px"
                >
                  <div class="swipeBtn" style="transform: rotate(180deg)" />
                </div>
                <div
                  class="iconBackground swiper-button-next-choose-us"
                  slot="button-next"
                >
                  <div class="swipeBtn" />
                </div>
              </v-row>
            </v-container>
          </v-main>
          <div class="custom-pagination" style="margin-top: 32px"></div>
        </div>
      </v-container>
    </v-main>
    <div
      style="background: rgba(240, 237, 229, 0.9); position: relative"
      :style="
        $vuetify.breakpoint.smAndDown ? 'height: 25px;' : 'height: 100px;'
      "
    >
      <img
        src="@/assets/img/Backgrounds/contactBackgroundTopBack.svg"
        width="100%"
        height="auto"
        alt="background front"
        style="position: absolute; z-index: 1"
      />
      <img
        src="@/assets/img/Backgrounds/contactBackgroundTopFront.svg"
        width="100%"
        height="auto"
        alt="background front"
        style="position: absolute; z-index: 5"
      />
      <img
        src="@/assets/img/Backgrounds/contactBackgroundTop.svg"
        width="100%"
        height="auto"
        alt="background front"
        style="position: absolute; z-index: 10"
      />
    </div>
  </div>
</template>

<script>
import { Pagination, Navigation } from "vue-awesome-swiper";
import reviewCard from "./reviewCard.vue";
import reviewService from "../../../requests/Admin/reviewService";
export default {
  components: { reviewCard },
  data: () => ({
    swiperOptions: {
      slidesPerView: 1,
      spaceBetween: 30,
      pagination: {
        el: ".custom-pagination",
        clickable: true,
        renderBullet: function () {
          return `<span class="dot swiper-pagination-bullet"></span>`;
        },
      },
      navigation: {
        nextEl: ".swiper-button-next-reviews",
        prevEl: ".swiper-button-prev-reviews",
      },
      modules: [Navigation, Pagination],
    },
    swiperMobileOptions: {
      slidesPerView: 1,
      spaceBetween: 20,
      pagination: {
        el: ".custom-pagination",
        clickable: true,
        renderBullet: function () {
          return `<span class="dot swiper-pagination-bullet"></span>`;
        },
      },
      navigation: {
        nextEl: ".swiper-button-next-reviews",
        prevEl: ".swiper-button-prev-reviews ",
      },
      modules: [Navigation, Pagination],
    },
    reviewsList: [],
    isShowLoader: false,
  }),
  mounted() {
    this.getReviews();
  },
  methods: {
    async getReviews() {
      await reviewService.getReviews().then((res) => (this.reviewsList = res));
    },
    goNext() {
      document.getElementById("button-next").click();
    },
    goPrev() {
      document.getElementById("button-prev").click();
    },
  },
};
</script>

<style>
.swiper-slide {
  width: 100% !important;
  box-sizing: border-box;
}
.dot {
  width: 12px;
  height: 12px;
  background: rgba(192, 149, 89, 0.3);
  border-radius: 50%;
  margin: 0 6px;
  opacity: 1;
  transition: background 0.3s;
}
.swiper-pagination-bullet-active {
  background: #c09559;
}
</style>
<style scoped>
.custom-pagination {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

.dot {
  width: 12px;
  height: 12px;
  background: lightgray;
  border-radius: 50%;
  margin: 0 6px;
  opacity: 1;
  transition: background 0.3s;
}
</style>